import {AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';
import {IPayload, IVerify} from '@/features/core/components/login/types';

export const signInCurrentUser = (payload: IPayload): Promise<AxiosResponse> => HttpRequest.post('/api/auth/signin', payload);

export const verifyCurrentUser = (payload: IVerify): Promise<AxiosResponse> => HttpRequest.post('/api/auth/emailed/verifyed', payload);

export const signOutCurrentUser = (): Promise<AxiosResponse> => HttpRequest.delete('/api/auth/signout');
